import type { OptionsObject } from "notistack";
import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

export const getPermissionSnackbarOptions = (
  options?: Omit<Partial<OptionsObject & { message: ReactNode }>, "variant">
) =>
  ({
    message: <FormattedMessage id="error.access" />,
    preventDuplicate: true,
    ...options,
    variant: "permission",
  }) as const;
